'use strict';

var _regeneratorRuntime = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _awaitAsyncGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var CID = require('cids');

var configure = require('./lib/configure');

var toUrlSearchParams = require('./lib/to-url-search-params');

module.exports = configure(function (api) {
  return (
    /*#__PURE__*/
    function () {
      var _ls = _wrapAsyncGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(path) {
        var options,
            res,
            _iteratorNormalCompletion,
            _didIteratorError,
            _iteratorError,
            _iterator,
            _step,
            _value,
            result,
            _iteratorNormalCompletion2,
            _didIteratorError2,
            _iteratorError2,
            _iterator2,
            _step2,
            link,
            entry,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _context.next = 3;
                return _awaitAsyncGenerator(api.post('ls', {
                  timeout: options.timeout,
                  signal: options.signal,
                  searchParams: toUrlSearchParams(_objectSpread({
                    arg: "".concat(Buffer.isBuffer(path) ? new CID(path) : path)
                  }, options)),
                  headers: options.headers
                }));

              case 3:
                res = _context.sent;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context.prev = 6;
                _iterator = _asyncIterator(res.ndjson());

              case 8:
                _context.next = 10;
                return _awaitAsyncGenerator(_iterator.next());

              case 10:
                _step = _context.sent;
                _iteratorNormalCompletion = _step.done;
                _context.next = 14;
                return _awaitAsyncGenerator(_step.value);

              case 14:
                _value = _context.sent;

                if (_iteratorNormalCompletion) {
                  _context.next = 58;
                  break;
                }

                result = _value;
                result = result.Objects;

                if (result) {
                  _context.next = 20;
                  break;
                }

                throw new Error('expected .Objects in results');

              case 20:
                result = result[0];

                if (result) {
                  _context.next = 23;
                  break;
                }

                throw new Error('expected one array in results.Objects');

              case 23:
                result = result.Links;

                if (Array.isArray(result)) {
                  _context.next = 26;
                  break;
                }

                throw new Error('expected one array in results.Objects[0].Links');

              case 26:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 29;
                _iterator2 = result[Symbol.iterator]();

              case 31:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 41;
                  break;
                }

                link = _step2.value;
                entry = {
                  name: link.Name,
                  path: path + '/' + link.Name,
                  size: link.Size,
                  cid: new CID(link.Hash),
                  type: typeOf(link),
                  depth: link.Depth || 1
                };

                if (link.Mode) {
                  entry.mode = parseInt(link.Mode, 8);
                }

                if (link.Mtime !== undefined && link.Mtime !== null) {
                  entry.mtime = {
                    secs: link.Mtime
                  };

                  if (link.MtimeNsecs !== undefined && link.MtimeNsecs !== null) {
                    entry.mtime.nsecs = link.MtimeNsecs;
                  }
                }

                _context.next = 38;
                return entry;

              case 38:
                _iteratorNormalCompletion2 = true;
                _context.next = 31;
                break;

              case 41:
                _context.next = 47;
                break;

              case 43:
                _context.prev = 43;
                _context.t0 = _context["catch"](29);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 47:
                _context.prev = 47;
                _context.prev = 48;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 50:
                _context.prev = 50;

                if (!_didIteratorError2) {
                  _context.next = 53;
                  break;
                }

                throw _iteratorError2;

              case 53:
                return _context.finish(50);

              case 54:
                return _context.finish(47);

              case 55:
                _iteratorNormalCompletion = true;
                _context.next = 8;
                break;

              case 58:
                _context.next = 64;
                break;

              case 60:
                _context.prev = 60;
                _context.t1 = _context["catch"](6);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 64:
                _context.prev = 64;
                _context.prev = 65;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context.next = 69;
                  break;
                }

                _context.next = 69;
                return _awaitAsyncGenerator(_iterator.return());

              case 69:
                _context.prev = 69;

                if (!_didIteratorError) {
                  _context.next = 72;
                  break;
                }

                throw _iteratorError;

              case 72:
                return _context.finish(69);

              case 73:
                return _context.finish(64);

              case 74:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 60, 64, 74], [29, 43, 47, 55], [48,, 50, 54], [65,, 69, 73]]);
      }));

      function ls(_x) {
        return _ls.apply(this, arguments);
      }

      return ls;
    }()
  );
});

function typeOf(link) {
  switch (link.Type) {
    case 1:
    case 5:
      return 'dir';

    case 2:
      return 'file';

    default:
      return 'unknown';
  }
}